import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'
import { map, of, tap } from 'rxjs'
import { AppService } from '../services/app.service'

export const industrySectorResolver: ResolveFn<boolean> = (route, state) => {
  const _AppService = inject(AppService)
  if (_AppService.industrySectors && _AppService.industrySectors.length > 0) return of(true)
  return _AppService.getIndustrySectorList().pipe(
    tap((response) => {
      _AppService.industrySectors = response.data.industry_sectors
    }),
    map(() => true)
  )
}
